import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import dayjs from 'dayjs';

export default {
    state() {
        return {
            mailboxLoading: true,
            mailboxType: null,
            messages: [],
            newMessagesLoading: true,
            newMessages: [],
            sentMessages: [],
            messageMeta: {},
            messageCategoryOptions: [
                {
                    label: 'Correspondence',
                },
                {
                    label: 'Meetings',
                },
                {
                    label: 'Service Renewal',
                },
                {
                    label: 'Annual Review',
                },
                {
                    label: 'IMS',
                },
                {
                    label: 'DPS',
                },
                {
                    label: 'Feedback',
                },
                {
                    label: 'Investments',
                },
                {
                    label: 'clarityPLATFORM',
                },
            ],
            dateOptions: [
                {
                    label: 'All',
                },
                {
                    label: 'Last Week',
                },
                {
                    label: 'Last Month',
                },
                {
                    label: 'Last Year',
                },
                {
                    label: 'Select Date Range',
                },
            ],
            senderOptions: {
                inbound: [],
                outbound: [],
            },
            mailDateRangeFrom: dayjs().subtract(1, 'year').toDate(),
            mailDateRangeTo: dayjs().toDate(),
            correspondentFilter: [],
            categoryFilter: [],
            currentMessage: null,
            recipientOptions: [
                {
                    name: 'Admin Team',
                    uuid: 'c_admin',
                    email: 'adminteam@clarityglobal.com',
                },
                {
                    name: 'IMS Team',
                    uuid: 'c_ims',
                    email: 'ims@clarityglobal.com',
                },
            ],
            additionalRecipients: [],
            recipientList: [],
            senderList: [],
            globalTriggerMessage: {},
            messageRecovery: false,
        };
    },
    mutations,
    actions,
    getters,
};
